import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { projectSlice } from '../../../Flux/Slice/Project/ProjectSlice.js'
import { BlastSource } from '../../../Model/Project/BlastSource.js'
import { selectTotalSamples, useGetBlastStatistics } from '../../../Flux/Selector/index.js'
import { BeakerIcon } from '@heroicons/react/24/outline'
import { TooltipTrigger } from '../../../Provider/TooltipManager.js'

interface BlastStatisticsWidgetProps {
  projectId: string
}

export const BlastStatisticsWidget = ({ projectId }: BlastStatisticsWidgetProps) => {
  const [selectedBlastType, setSelectedBlastType] = useState<BlastSource>(BlastSource.BOLD)
  const dispatch = useDispatch()
  const blastStats = useGetBlastStatistics(projectId, selectedBlastType)

  const sampleCount = useSelector(selectTotalSamples)

  useEffect(() => {
    dispatch(projectSlice.actions.getOtuProcessIdsRequest({ projectId, blastType: selectedBlastType }))
  }, [dispatch, projectId, selectedBlastType, sampleCount])

  const handleBlastTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedBlastType(e.target.value as BlastSource)
  }

  return (
    <div className="flex items-center gap-2">
      <BeakerIcon className="w-6 h-6 text-purple-600" />
      <div className="flex flex-row">
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <TooltipTrigger tooltip={`Features without process id: ${blastStats.data?.missedOtus || 0}`}>
              <p data-testid={'blast-id-count'} className="text-lg font-medium">
                {blastStats.loading && blastStats.data?.blastIds === undefined ? 'loading...' : blastStats.data?.blastIds?.length || 0}
              </p>
            </TooltipTrigger>
          </div>
          <p className="text-sm text-slate-500">Blast IDs</p>
        </div>
        <div className="flex flex-col justify-center ml-2">
          <select className="select select-xs select-bordered" value={selectedBlastType} onChange={handleBlastTypeChange}>
            {Object.values(BlastSource).map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  )
}
